import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/processes/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllProcessTypes: config.endpoints.backend + 'processtypes/getall',
        endpointDelete: `${config.endpoints.backend}processes/delete`,
        endpoint: config.endpoints.backend + 'processes/getall'
    }

    const pathsForm = {
        endpointSave: config.endpoints.backend + 'processes/save',
        endpointGetById: config.endpoints.backend + 'processes/getById',
        endpointGetByProcessNumber: config.endpoints.backend + 'processes/getByProcessNumber',
        endpointGetAllProcessTypes: config.endpoints.backend + 'processtypes/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'pdc_process_type_id',
                type: 'select',
                label: 'Tipo de Processo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProcessTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'opening_date',
                name_start: 'opening_date_start',
                name_end: 'opening_date_end',
                type: 'date_period',
                label: 'Data de abertura',
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            }
        ]
    }

    let list = {
        labelTitle: 'Lista de Processos',
        labelTitleButtonAdd: 'Incluir novo Processo',
        fieldsShowOnDelete: ['name'],
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'project_name',
                label: 'Projeto'
            },
            {
                name: 'process_number',
                label: 'Número',
                width: '12%'
            },
            {
                name: 'opening_date',
                label: 'Data de Abertura',
                width: '10%'
            },
            {
                name: 'process_type',
                label: 'Tipo',
                width: '10%'
            }
        ]
    };

    list = { ...list, ...paths };

    let form = {
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: true
                },
                columnSize: 12,
            },
            {
                name: 'process_number',
                type: 'text',
                mask: '999999/9999',
                label: 'Número do Processo',
                validations: {
                    required: true,
                    process_number: true
                },
                columnSize: 12
            },
            {
                name: 'pdc_process_type_id',
                type: 'select',
                label: 'Tipo de Processo',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllProcessTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 12,
            },
            {
                name: 'opening_date',
                type: 'date',
                label: 'Data de Abertura',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'object',
                type: 'textarea',
                label: 'Objeto',
                validations: {
                    required: true
                },
                columnSize: 12
            }
        ],
        ...pathsForm,
        labelTitleModal: 'Visualizar Processo'
    }

    list.formToModal = form;

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
